import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { addGeneratedTemplates } from '../actions';
import { TemplateActions } from '../types';

import { initialTemplateState } from '.';

const generatedTemplateListReducer: Reducer<typeof initialTemplateState, TemplateActions> = (
  state = initialTemplateState,
  action
) => {
  switch (action.type) {
    case getType(addGeneratedTemplates): {
      const { offset: prevOffset, limit } = state.generatedItems;
      const { list: prevList, count: prevCount } = state.templateItems;
      const { count, content: generatedList } = action.payload;

      const offset = prevOffset + limit;
      const newList = [...prevList, ...generatedList.slice(prevOffset, offset)];
      const newCount = prevCount ? prevCount + limit : prevCount;

      return {
        ...state,
        templateItems: {
          ...state.templateItems,
          list: newList,
          isPending: false,
          count: newCount,
          isAllLoaded: newList.length >= count
        },
        generatedItems: {
          ...state.generatedItems,
          count,
          offset,
          list: generatedList
        }
      };
    }
    default:
      return state;
  }
};

export default generatedTemplateListReducer;
